module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [(_vm.isValidAccount) ? _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [(_vm.showUpdateInfo) ? _c('v-alert', {
    attrs: {
      "border": "top",
      "prominent": "",
      "colored-border": "",
      "type": "warning"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "grow"
  }, [_vm._v("Please update your profile with all required fields.")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.openedPanels),
      callback: function($$v) {
        _vm.openedPanels = $$v
      },
      expression: "openedPanels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Contact Information *")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    staticClass: "pp-section text-center",
    attrs: {
      "xs": "12",
      "sm": "12",
      "md": "2"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "120"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.activeUser.avatar,
      "alt": "User Profile Image"
    },
    on: {
      "click": _vm.changeProfilePicture
    }
  })]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "text-center mt-2",
    attrs: {
      "small": "",
      "color": "warning"
    },
    on: {
      "click": _vm.changeProfilePicture
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "15"
    }
  }, [_vm._v("mdi-pencil")]), _vm._v(" Edit")], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "10"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [(_vm.userData.reqIgHandle) ? _c('v-text-field', {
    attrs: {
      "label": "Instagram Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.reqIgHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "reqIgHandle", $$v)
      },
      expression: "userData.reqIgHandle"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Instagram Account",
      "disabled": _vm.userData.igHandle !== ''
    },
    model: {
      value: (_vm.userData.igHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "igHandle", $$v)
      },
      expression: "userData.igHandle"
    }
  }), _vm._v(" "), (_vm.userData.reqIgHandle) ? _c('v-icon', _vm._g({
    staticStyle: {
      "height": "100%",
      "margin-top": "25px",
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("mdi-account-clock")]) : _vm._e(), _vm._v(" "), (!_vm.userData.igHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update Instagram")])])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Facebook Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.fbHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "fbHandle", $$v)
      },
      expression: "userData.fbHandle"
    }
  }), _vm._v(" "), (_vm.userData.fbHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "href": 'https://www.facebook.com/' + _vm.userData.fbHandle,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "x-small": "",
      "color": "warning"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("mdi-facebook")])]
      }
    }], null, false, 2648339379)
  }, [_vm._v(" "), _c('span', [_vm._v("View Facebook Profile")])])], 1) : _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update Facebook")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [(_vm.userData.reqTikTokHandle) ? _c('v-text-field', {
    attrs: {
      "label": "TikTok Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.reqTikTokHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "reqTikTokHandle", $$v)
      },
      expression: "userData.reqTikTokHandle"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "TikTok Account",
      "disabled": _vm.userData.tiktokHandle !== ''
    },
    model: {
      value: (_vm.userData.tiktokHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "tiktokHandle", $$v)
      },
      expression: "userData.tiktokHandle"
    }
  }), _vm._v(" "), (_vm.userData.reqTikTokHandle) ? _c('v-icon', _vm._g({
    staticStyle: {
      "height": "100%",
      "margin-top": "25px",
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("mdi-account-clock")]) : _vm._e(), _vm._v(" "), (!_vm.userData.tiktokHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update TikTok")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [(_vm.userData.reqYoutubeHandle) ? _c('v-text-field', {
    attrs: {
      "label": "Youtube Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.reqYoutubeHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "reqYoutubeHandle", $$v)
      },
      expression: "userData.reqYoutubeHandle"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Youtube Account",
      "disabled": _vm.userData.youtubeHandle !== ''
    },
    model: {
      value: (_vm.userData.youtubeHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "youtubeHandle", $$v)
      },
      expression: "userData.youtubeHandle"
    }
  }), _vm._v(" "), (_vm.userData.reqYoutubeHandle) ? _c('v-icon', _vm._g({
    staticStyle: {
      "height": "100%",
      "margin-top": "25px",
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("mdi-account-clock")]) : _vm._e(), _vm._v(" "), (!_vm.userData.youtubeHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update Youtube")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "X (Twitter) Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.twitterHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "twitterHandle", $$v)
      },
      expression: "userData.twitterHandle"
    }
  }), _vm._v(" "), (_vm.userData.twitterHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "href": 'https://x.com/' + _vm.userData.twitterHandle,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "x-small": "",
      "color": "warning"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('img', _vm._g({
          staticClass: "x-logo-white",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "12",
            "height": "12",
            "alt": "X (Twitter)"
          }
        }, on))]
      }
    }], null, false, 2131544379)
  }, [_vm._v(" "), _c('span', [_vm._v("View X (Twitter) Profile")])])], 1) : _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update X (Twitter)")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [(_vm.userData.reqLinkedinHandle) ? _c('v-text-field', {
    attrs: {
      "label": "LinkedIn Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.reqLinkedinHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "reqLinkedinHandle", $$v)
      },
      expression: "userData.reqLinkedinHandle"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "LinkedIn Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.linkedinHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "linkedinHandle", $$v)
      },
      expression: "userData.linkedinHandle"
    }
  }), _vm._v(" "), (_vm.userData.reqLinkedinHandle) ? _c('v-icon', {
    staticStyle: {
      "height": "100%",
      "margin-top": "25px",
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-account-clock")]) : _vm._e(), _vm._v(" "), (_vm.userData.linkedinHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.userData.linkedinHandle,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "x-small": "",
      "color": "warning"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("mdi-linkedin")])]
      }
    }], null, false, 3145342333)
  }, [_vm._v(" "), _c('span', [_vm._v("View LinkedIn Profile")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.userData.linkedinHandle && !_vm.userData.reqLinkedinHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update LinkedIn")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "First Name",
      "error-messages": _vm.firstNameErrors,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.userData.firstName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.userData.firstName.$touch()
      }
    },
    model: {
      value: (_vm.userData.firstName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "firstName", $$v)
      },
      expression: "userData.firstName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Last Name"
    },
    model: {
      value: (_vm.userData.lastName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "lastName", $$v)
      },
      expression: "userData.lastName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Email Address",
      "error-messages": _vm.emailErrors,
      "required": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "input": _vm.removeSpaces,
      "paste": _vm.preventPasteSpaces,
      "blur": function($event) {
        return _vm.$v.userData.email.$touch()
      }
    },
    model: {
      value: (_vm.userData.email),
      callback: function($$v) {
        _vm.$set(_vm.userData, "email", $$v)
      },
      expression: "userData.email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Contact Number"
    },
    model: {
      value: (_vm.userData.phone),
      callback: function($$v) {
        _vm.$set(_vm.userData, "phone", $$v)
      },
      expression: "userData.phone"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Billing Information")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('table', [_c('tr', [_c('td', [_vm._v("Full Name "), _c('small', [_vm._v("(as per bank account)")])]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.fullName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "fullName", $$v)
      },
      expression: "userData.fullName"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Country")]), _vm._v(" "), _c('td', [_c('div', [_c('v-select', {
    attrs: {
      "label": "Country",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name",
      "attach": "",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "change": _vm.changeCountry
    },
    model: {
      value: (_vm.userData.country),
      callback: function($$v) {
        _vm.$set(_vm.userData, "country", $$v)
      },
      expression: "userData.country"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bank Name")]), _vm._v(" "), _c('td', [_c('div', [_c('v-combobox', {
    staticClass: "edit-field",
    attrs: {
      "items": _vm.bankNames,
      "item-text": "bank",
      "item-value": "bank",
      "search-input": _vm.newBankName,
      "attach": "",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newBankName = $event
      },
      "update:search-input": function($event) {
        _vm.newBankName = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [(_vm.newBankName) ? _c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v(_vm._s(_vm.newBankName))]) : _vm._e()])]
      },
      proxy: true
    }], null, false, 2535767177),
    model: {
      value: (_vm.userData.bankName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "bankName", $$v)
      },
      expression: "userData.bankName"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bank Account Number")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#################'),
      expression: "'#################'"
    }],
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.userData, "bankAccount", $$v)
      },
      expression: "userData.bankAccount"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Billing Email")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.billingEmail),
      callback: function($$v) {
        _vm.$set(_vm.userData, "billingEmail", $$v)
      },
      expression: "userData.billingEmail"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mailing Address")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.mailingAddress),
      callback: function($$v) {
        _vm.$set(_vm.userData, "mailingAddress", $$v)
      },
      expression: "userData.mailingAddress"
    }
  }, _vm.on))], 1)])])])])], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("More About You")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Gender",
      "items": _vm.userGender_options,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.userData.gender),
      callback: function($$v) {
        _vm.$set(_vm.userData, "gender", $$v)
      },
      expression: "userData.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Your Birthday",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.userData.birthday),
            callback: function($$v) {
              _vm.$set(_vm.userData, "birthday", $$v)
            },
            expression: "userData.birthday"
          }
        }, on))]
      }
    }], null, false, 2796975143),
    model: {
      value: (_vm.bdPicker),
      callback: function($$v) {
        _vm.bdPicker = $$v
      },
      expression: "bdPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.bdPicker = false
      }
    },
    model: {
      value: (_vm.userData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.userData, "birthday", $$v)
      },
      expression: "userData.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ethnicity",
      "items": _vm.ethnicity_options,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.userData.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.userData, "ethnicity", $$v)
      },
      expression: "userData.ethnicity"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Occupation"
    },
    model: {
      value: (_vm.inputedRates.occupation),
      callback: function($$v) {
        _vm.$set(_vm.inputedRates, "occupation", $$v)
      },
      expression: "inputedRates.occupation"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_vm._v("\n                  What is your content niche/focus?\n                  "), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "primary--text",
      "max": "3",
      "column": ""
    },
    model: {
      value: (_vm.userData.keywords),
      callback: function($$v) {
        _vm.$set(_vm.userData, "keywords", $$v)
      },
      expression: "userData.keywords"
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_vm._v("\n                  One liner about you (could emphasise on your niche to best represent your profile)\n                  "), _c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": "",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.inputedRates.aboutYou),
      callback: function($$v) {
        _vm.$set(_vm.inputedRates, "aboutYou", $$v)
      },
      expression: "inputedRates.aboutYou"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.inputedRates.type),
      callback: function($$v) {
        _vm.$set(_vm.inputedRates, "type", $$v)
      },
      expression: "inputedRates.type"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "agency",
      "label": "Agency"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "direct",
      "label": "Direct"
    }
  })], 1), _vm._v(" "), (_vm.inputedRates.type === 'agency') ? _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Agency Name",
      "type": "textbox",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.inputedRates.agencyName),
      callback: function($$v) {
        _vm.$set(_vm.inputedRates, "agencyName", $$v)
      },
      expression: "inputedRates.agencyName"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_c('p', [_vm._v("Your rates\n                  "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(in SGD per item)")])])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', {
    attrs: {
      "id": "profile-rate-card-form"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.formConfig.sections), function(section, index) {
    return _c('v-col', {
      key: index,
      class: section.class ? section.class : 'xs12 md6',
      style: (section.style || '')
    }, [_c('div', _vm._l((section.fields), function(field, index) {
      return _c('v-col', {
        key: index,
        class: field.class ? field.class : 'xs12 md6',
        style: (field.style || '')
      }, [(field.label !== '' && !field.hideInternal) ? _c('p', {
        class: ("h4 font-weight-bold mb-2 " + (field.labelClass || ''))
      }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
        staticClass: "red--text"
      }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (field.type === 'number') ? _c('div', {
        staticClass: "d-flex flex-row pl-3"
      }, [_c('v-select', {
        staticClass: "currency-select",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "items": _vm.currenyOptions,
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: (_vm.inputedRates[((field.name) + "Currency")]),
          callback: function($$v) {
            _vm.$set(_vm.inputedRates, ((field.name) + "Currency"), _vm._n($$v))
          },
          expression: "inputedRates[`${field.name}Currency`]"
        }
      }), _vm._v(" "), (field.type === 'number') ? _c('v-text-field', {
        staticClass: "purple-input",
        attrs: {
          "type": "number",
          "outlined": "",
          "dense": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.inputedRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.inputedRates, field.name, _vm._n($$v))
          },
          expression: "inputedRates[field.name]"
        }
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.type === 'textbox' && !field.hideInternal) ? _c('v-text-field', {
        staticClass: "purple-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "textbox",
          "outlined": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.inputedRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.inputedRates, field.name, $$v)
          },
          expression: "inputedRates[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
        attrs: {
          "filled": "",
          "auto-grow": "",
          "hint": field.hint || '',
          "persistent-hint": field.hint ? true : false,
          "placeholder": field.placeholder,
          "required": "",
          "hide-details": "auto"
        },
        model: {
          value: (_vm.inputedRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.inputedRates, field.name, $$v)
          },
          expression: "inputedRates[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', [_c('custom-file-upload', {
        attrs: {
          "refresh": _vm.fileUploadRefresh,
          "multiple": true
        },
        on: {
          "setMedias": _vm.updatePricingDecks
        }
      }), _vm._v(" "), (_vm.inputedRates.pricingDecks.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
        return _c('v-col', {
          key: index,
          staticClass: "d-flex child-flex",
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "2",
            "lg": "1"
          }
        }, [_c('v-hover', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var hover = ref.hover;

              return [_c('v-card', {
                staticClass: "d-flex",
                attrs: {
                  "flat": "",
                  "tile": "",
                  "elevation": hover ? 16 : 2
                }
              }, [_c('v-img', {
                staticClass: "grey lighten-2",
                attrs: {
                  "src": img.url,
                  "lazy-src": img.url,
                  "aspect-ratio": "1"
                }
              }), _vm._v(" "), _c('v-overlay', {
                attrs: {
                  "absolute": ""
                }
              }, [_c('v-btn', {
                attrs: {
                  "dark": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.deleteImage(index)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "color": "red"
                }
              }, [_vm._v("cancel")])], 1)], 1)], 1)]
            }
          }], null, true)
        })], 1)
      }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.type === 'multiple') ? _c('div', [_vm._l((_vm.inputedRates[field.name]), function(multipleOne, pIndex) {
        return _c('v-list', {
          key: pIndex
        }, [_c('v-list-item', {
          staticClass: "pa-0"
        }, _vm._l((field.options), function(multipleOption, oIndex) {
          return _c('v-list-item-content', {
            key: oIndex,
            style: (multipleOption.style || '')
          }, [(multipleOption.type === 'select') ? _c('v-select', {
            staticClass: "pr-1",
            style: (multipleOption.style || ''),
            attrs: {
              "items": multipleOption.options,
              "item-value": "value",
              "item-text": "label",
              "hide-details": "",
              "label": multipleOption.label,
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (_vm.inputedRates[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.inputedRates[field.name][pIndex], multipleOption.name, $$v)
              },
              expression: "inputedRates[field.name][pIndex][multipleOption.name]"
            }
          }) : _vm._e(), _vm._v(" "), (multipleOption.type === 'textbox') ? _c('v-text-field', {
            staticClass: "px-1",
            attrs: {
              "dense": "",
              "outlined": "",
              "hide-details": "",
              "placeholder": multipleOption.placeholder
            },
            model: {
              value: (_vm.inputedRates[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.inputedRates[field.name][pIndex], multipleOption.name, $$v)
              },
              expression: "inputedRates[field.name][pIndex][multipleOption.name]"
            }
          }) : _vm._e(), _vm._v(" "), (multipleOption.type === 'number') ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-select', {
            staticClass: "currency-select",
            attrs: {
              "items": _vm.currenyOptions,
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (_vm.inputedRates[field.name][pIndex][((multipleOption.name) + "Currency")]),
              callback: function($$v) {
                _vm.$set(_vm.inputedRates[field.name][pIndex], ((multipleOption.name) + "Currency"), _vm._n($$v))
              },
              expression: "inputedRates[field.name][pIndex][`${multipleOption.name}Currency`]"
            }
          }), _vm._v(" "), _c('v-text-field', {
            class: multipleOption.class || '',
            attrs: {
              "type": "number",
              "dense": "",
              "outlined": "",
              "hide-details": "",
              "placeholder": multipleOption.name
            },
            model: {
              value: (_vm.inputedRates[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.inputedRates[field.name][pIndex], multipleOption.name, _vm._n($$v))
              },
              expression: "inputedRates[field.name][pIndex][multipleOption.name]"
            }
          })], 1) : _vm._e(), _vm._v(" "), (multipleOption.type === 'delete') ? _c('v-btn', {
            attrs: {
              "color": "danger",
              "text": "",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                _vm.inputedRates[field.name].splice(pIndex, 1)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "red"
            }
          }, [_vm._v("mdi-delete-forever")])], 1) : _vm._e()], 1)
        }), 1), _vm._v(" "), (_vm.inputedRates[field.name][pIndex][field.child.parentName] === 'others') ? _c('v-list', [_c('v-text-field', {
          staticClass: "px-2",
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": field.child.placeholder
          },
          model: {
            value: (_vm.inputedRates[field.name][pIndex][field.child.name]),
            callback: function($$v) {
              _vm.$set(_vm.inputedRates[field.name][pIndex], field.child.name, $$v)
            },
            expression: "inputedRates[field.name][pIndex][field.child.name]"
          }
        })], 1) : _vm._e()], 1)
      }), _vm._v(" "), _c('v-list', {
        staticClass: "float-right"
      }, [_c('v-list-item', {
        staticStyle: {
          "margin-top": "-20px"
        }
      }, [_c('v-btn', {
        attrs: {
          "small": "",
          "color": "secondary"
        },
        on: {
          "click": function($event) {
            return _vm.addPlatform(field.name)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                                ")], 1)], 1)], 1)], 2) : _vm._e()], 1)
    }), 1)])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0 font-weight-light",
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.editProfile
    }
  }, [_vm._v("Update Profile")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isValidAccount) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('p', [_c('b', [_vm._v("Notice:")]), _vm._v(" "), _c('i', [_vm._v("\n          Your account is not connected with your Instagram. Please click the button below to connect your Instagram account. \n          "), _c('br'), _vm._v("If you have registered with Kobe before, please reauthorise and refresh due to the change of Facebook API requirement.\n        ")])]), _vm._v(" "), _c('connect-instagram')], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n        Updating...\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('change-avatar-modal', {
    attrs: {
      "value": _vm.changeAvatarDialog
    },
    on: {
      "changeAvatar": _vm.uploadAvatar
    },
    model: {
      value: (_vm.changeAvatarDialog),
      callback: function($$v) {
        _vm.changeAvatarDialog = $$v
      },
      expression: "changeAvatarDialog"
    }
  }), _vm._v(" "), _c('update-platform-modal', {
    attrs: {
      "value": _vm.updatePlatformDialog
    },
    on: {
      "connectIG": _vm.connectInstagram
    },
    model: {
      value: (_vm.updatePlatformDialog),
      callback: function($$v) {
        _vm.updatePlatformDialog = $$v
      },
      expression: "updatePlatformDialog"
    }
  }), _vm._v(" "), _c('billing-info-modal', {
    attrs: {
      "value": _vm.billingInfoDialog,
      "infData": _vm.userData
    },
    on: {
      "updated": function($event) {
        return _vm.getUserProfile()
      }
    },
    model: {
      value: (_vm.billingInfoDialog),
      callback: function($$v) {
        _vm.billingInfoDialog = $$v
      },
      expression: "billingInfoDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14d77608"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/User/Profile.vue
// module id = 2012
// module chunks = 0